angular.module('unergie.main')
.factory('OfferService', (DataAccessOffers) => {
    const refPromise = new Promise((resolve, reject) => {
        DataAccessOffers.getOffers().$promise.then((mapping) => {
            const offersMapping = _.compact(_.map(mapping, (m) => (!['EJP', 'TRV_REF', 'EARLY_BIRD'].includes(m.id) && { value: m.id, label: m.id })))
            resolve(offersMapping)
        })
    })

    const selectableOffersPromise = new Promise((resolve, reject) => {
        DataAccessOffers.getSelectableOffers().$promise.then((mapping) => {
            const offersMapping = _.compact(_.map(mapping.offers, (m) => ({ value: m.id, label: m.label })))
            resolve(offersMapping)
        })
    })

    return {
        refPromise,
        selectableOffersPromise,
    }
})
